module.exports = __webpack_public_path__ + "static/html-element-advanced_7-6e18ae0c1b0b766aaff8c16c7e16fad3.jpg";